module.exports = __webpack_public_path__ + "static/img/offer2.bcfa594.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/campaign/offer2.jpg
// module id = N7N4
// module chunks = 0